import styled from 'styled-components';

export const Header = styled.div`
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
`;
